import * as React from "react";
import * as ReactDOM from "react-dom";
import styled, { css } from "styled-components";

import { media } from "./common";
import { ReactNode } from "react";

interface State {
  hasScrollbar: boolean;
  buttonGroupWidth?: number;
  buttonGroupHeight?: number;
}

interface Props {
  className?: string;
  children?: ReactNode;
  noSpacing?: boolean;
}

class StickyButton extends React.Component<Props, State> {
  state: State = {
    hasScrollbar: false,
    buttonGroupWidth: undefined,
    buttonGroupHeight: undefined,
  };
  private stickyContainer = React.createRef<any>();
  private stickyContent = React.createRef<any>();

  componentDidMount() {
    this.updateButtonGroupWidthHeight();
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate(prevProps: Readonly<Props>) {
    if (prevProps.children !== this.props.children) {
      this.updateButtonGroupWidthHeight();
    }
  }

  updateButtonGroupWidthHeight() {
    const container = ReactDOM.findDOMNode(
      this.stickyContainer.current
    ) as HTMLDivElement;
    const content = ReactDOM.findDOMNode(
      this.stickyContent.current
    ) as HTMLDivElement;
    this.setState({
      buttonGroupWidth: container.clientWidth,
      buttonGroupHeight: content.clientHeight,
    });
  }

  render() {
    return (
      <StickyContainer
        ref={this.stickyContainer}
        height={this.props.noSpacing ? 0 : this.state.buttonGroupHeight}
      >
        <StickyContent
          ref={this.stickyContent}
          containerWidth={this.state.buttonGroupWidth}
          showShadow={this.state.hasScrollbar}
          className={this.props.className}
        >
          {this.props.children}
        </StickyContent>
      </StickyContainer>
    );
  }

  private handleScroll = () => {
    const viewPortBottom = window.innerHeight + window.scrollY;
    this.setState({
      hasScrollbar: viewPortBottom < document.body.scrollHeight,
    });
  };
}

const StickyContent = styled.div<{
  containerWidth?: number;
  showShadow: boolean;
}>`
  padding: 10px 0;
  background-color: #fff;
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  padding-left: 16px;
  padding-right: 16px;
  z-index: 3;
  min-width: 320px;
  ${media.md`
    left: auto;
    padding-left: 0;
    padding-right: 0;
  `};
  ${({ containerWidth }) =>
    containerWidth &&
    css`
      ${media.md`
        width: ${containerWidth + 30}px;
        margin-left: -15px;
        padding-left: 15px;
        padding-right: 15px;
      `};
    `};
  ${({ showShadow }) =>
    showShadow &&
    css`
      box-shadow: 0px -7px 11px -14px black;
    `};
`;

const StickyContainer = styled.div<{ height?: number }>`
  &::after {
    content: " ";
    height: ${({ height }) => height}px;
    display: block;
  }
`;
export { StickyButton };
